import { render, staticRenderFns } from "./EnumerationCreate.vue?vue&type=template&id=263a503b"
import script from "./EnumerationCreate.vue?vue&type=script&lang=ts"
export * from "./EnumerationCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports